export const loadData = {
  emptyText: "Add loads to get started",
  btnText: "Add New Loads",
  btnTextGoRouter: "/dispatch/loadAdd?type=add&sourceType=EmptyState",
  icon: "loads-empty-state",
  emptyTextWidth: 400,
  showbtn2: false,
  showbtn: true,
  showContentContainer: true,
  btnTextJumpRouter: true,
  btnText2JumpRouter: true,
  btnText2GoRouter: "/dispatch/import",
  btnTextDes: "",
  contentList: [
    {
      src: require("../../../images/load-empty-img1.png"),
      title: "Centralized Load Management",
      describe:
        "Easily manage loads using map or list views, sorting loads by location, status or customized filters you create",
      itemWidth: 225,
    },
    {
      src: require("../../../images/driver-empty-img2.png"),
      title: "Quick, Easy Dispatch",
      describe:
        "Dispatching loads directly to the Trucker Path app makes for a seamless experience",
    },
    {
      src: require("../../../images/load-empty-img2.png"),
      title: "Tracking & Notifications",
      describe:
        "You and your customers stay informed of key events like loading, pick-up, arrival, detention and more",
    },
    {
      src: require("../../../images/driver-empty-img5.png"),
      title: "Digitize Your Documents",
      describe:
        "With just a click, drivers capture and share the docs you need to speed up billing & collections",
    },
  ],
};
export const driverData = {
  emptyText: "Add drivers to get started",
  btnText: "Add New Drivers",
  btnTextGoRouter: "/driver/driverAdd?type=add&sourceType=Empty State",
  icon: "driver-empty-state",
  disabled: false,
  noPermission: false,
  btnTextJumpRouter: true,
  btnText2JumpRouter: true,
  emptyTextWidth: 400,
  showbtn: true,
  showContentContainer: true,
  showbtn2: false,
  contentList: [
    {
      src: require("../../../images/driver-empty-img1.png"),
      title: "Real Truck Navigation",
      describe:
        "Enjoy the most widely used truck navigation available, trusted by more than 1 million drivers monthly",
      itemWidth: 220,
    },
    {
      src: require("../../../images/driver-empty-img2.png"),
      title: "Quick, Easy Dispatch",
      describe:
        "Dispatching loads directly to the Trucker Path app makes for a seamless experience",
      itemWidth: 220,
    },
    {
      src: require("../../../images/driver-empty-img3.png"),
      title: "Driver Management",
      describe:
        "Easily view drivers’ activities, compliance, productivity and real-time status",
      itemWidth: 240,
    },
    {
      src: require("../../../images/driver-empty-img4.png"),
      title: "Instant Messaging & Communication",
      describe:
        "Stay in sync with your drivers via multimedia messaging and location pins",
      itemWidth: 235,
    },
    {
      src: require("../../../images/driver-empty-img5.png"),
      title: "Digitize Your Documents",
      describe:
        "With just a click, drivers can capture and share docs you need to speed up billing & collections",
      itemWidth: 220,
    },
  ],
};
export const assetTruckData = {
  icon: "truck-empty-state",
  emptyText: "Add new trucks to start",
  btnText: "Add New Trucks",
  btnTextGoRouter: "/assets/create/truck?type=add&typeFrom=Truck",
  btnText2: "Connect your ELD to check real-time locations of your trucks",
  subBtnIcon: "icon-16-go",
  showSubBtnIcon2: true,
  showbtn: true,
  btnTextJumpRouter: true,
  emptyTextWidth: 400,
  showbtn2: true,
  btnText2GoRouter: "/setting/eld?fromType=noConnectEld",
  btnText2JumpRouter: true,
  btnTextDes: "",
  title: "test",
  contentList: [
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
  ],
};
export const assetTrailerData = {
  icon: "trailers-empty-state",
  emptyText: "Add trailers to get started",
  btnText: "Add New Trailers",
  btnTextGoRouter: "/assets/create/trailer?type=add&typeFrom=Trailer",
  showbtn: true,
  showbtn2: false,
  emptyTextWidth: 400,
  btnTextJumpRouter: true,
  btnTextDes: "",
  title: "test",
  contentList: [
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
  ],
};
export const documentData = {
  icon: "doc-empty-state",
  emptyText: "Add drivers to collect documents",
  btnText: "Upload document from to discard ",
  btnText2: "Watch a video",
  showbtn2: true,
  showbtn: true,
  emptyTextWidth: 400,
  showSubBtnIcon: true,
  subBtnIcon: "onboarding-video-play",
  showContentContainer: true,
  btnTextDes: "",
  showMainDescribe: true,
  mainDescribe:
    "Drivers added to your fleet will be able to scan and share documents with you directly",
  contentList: [
    {
      src: require("../../../images/driver-empty-img5.png"),
      title: "Powerful Document Capture",
      describe:
        "In-app feature for drivers enables them to capture paperwork images and share them as high-res PDFs",
    },
    {
      src: require("../../../images/doc-empty-img1.png"),
      title: "Instantly Collect Essential Documents",
      describe:
        "Drivers easily capture and instantly share essential BOLs, PODs, receipts and more",
    },
    {
      src: require("../../../images/doc-empty-img2.png"),
      title: "Easy Document Management and Sharing",
      describe:
        "Save and search your docs by attributes and easily share them with your customers",
    },
  ],
};
export const contactsData = {
  icon: "contacts-empty-state",
  emptyText: "Add new contacts to start",
  btnText: "Add New Contacts",
  showbtn: false,
  showbtn2: false,
  emptyTextWidth: 400,
  btnType: "dropdown",
  dropdownBtnText: "Add New Contacts",
  dropdownList: [
    {
      name: "Add Shippers",
      command: "Shipper",
    },
    {
      name: "Add Brokers",
      command: "Broker",
    },
    {
      name: "Add Locations",
      command: "Location",
    },
  ],
  jumpRouter: true,
  btnTextDes: "",
  title: "test",
  contentList: [
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
  ],
};
export const invoiceData = {
  icon: "invoice-empty-state",
  showMainDescribe: true,
  noShowEmptyText: true,
  mainDescribe: "Invoices can be created after you have completed a load",
  emptyText: "Invoices can be created after you have completed a load",
  btnText: "Add Your First invoice To Start",
  jumpRouter: true,
  mainDescribeWidth: 250,
  showbtn: false,
  showbtn2: false,
  btnTextDes: "",
  title: "test",
  contentList: [
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
    {
      src: require("@/assets/img/login/login_bg.jpg"),
      title: "test",
      describe: "test",
    },
  ],
};
